module.exports = __webpack_public_path__ + "media/images/aloe/logo/nephos-33cf9082ddba733aa0494963bdb62eba.png";